import axios from 'axios';
import { getAuthHeader } from '../utils/auth.js';

export const getMonthlyFinanceSummary = async (month) => {
  try {
    const response = await axios.get('/api/orders/finance/monthly_summary/', {
      params: {
        include_customer_stats: true,
        month: month
      },
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
